import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getQueryKey } from '../../services'
import { showErrorToast } from '@bpinternal/ui-kit-next'
import { handleHttpErrors } from '../../shared'
import { getApiClient } from '../../stores'

type UpdateWorkspaceParams = { workspaceId: string; onSuccess?: () => Promise<void> } & Parameters<
  ReturnType<typeof getApiClient>['updateWorkspaceMember']
>['0']

export function useUpdateWorkspaceMember() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ workspaceId, id, ...props }: UpdateWorkspaceParams) => {
      return await getApiClient({ workspaceId })
        .updateWorkspaceMember({ id, ...props })
        .catch(handleHttpErrors)
    },
    onSuccess: async (_, { onSuccess, workspaceId }) => {
      const queryKey = getQueryKey('workspaces_/$workspaceId_/members', { workspaceId })
      await queryClient.invalidateQueries({ queryKey })

      await onSuccess?.()
    },
    onError: (error: Error) => {
      showErrorToast(error.message)
    },
  })
}
